import { SlicePipe } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from '@shared/pipes';


export enum AvatarSizes {
    Small = 's',
    Medium = 'm',
    Large = 'l',
    ExtraLarge = 'xl',
}

@Component({
    selector: 'app-user-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': '"user-avatar user-avatar-" + size',
    },
    imports: [SlicePipe, SafePipe, TranslateModule],
})
export class AvatarComponent {
    @Input()
    public imageUrl: string;

    @Input()
    public hideLabel: boolean;

    @Input()
    public label: string;

    @Input()
    public size: AvatarSizes = AvatarSizes.Medium;
}
